import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AddLoanReason } from "../../actions/shg";
import Spinner from "../layout/Spinner";

const AddPurpose = ({
  auth: { isAuthenticated, user, users, loading },
  onAddLoanPurposeModalChange,
  AddLoanReason,
}) => {
  const [formData, setFormData] = useState({
    loanPurpose: "",
    isSubmitted: false,
  });

  const { loanPurpose } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const finalData = {
      loanPurpose: loanPurpose,
      userData: user,
    };
    AddLoanReason(finalData);

    setFormData({
      ...formData,
      loanPurpose: "",

      isSubmitted: true,
    });
    onAddLoanPurposeModalChange(true);
  };

  return !isAuthenticated || !user || !users || loading ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align">
        <form className="row" onSubmit={(e) => onSubmit(e)} autoComplete="off">
          <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="col-lg-10 col-md-12 col-sm-12 col-12">
              <label className="label-control"> Purpose* :</label>
              <input
                type="text"
                name="loanPurpose"
                value={loanPurpose}
                className="form-control"
                onChange={(e) => onInputChange(e)}
                required
              />
            </div>
          </div>

          <div className="col-md-12 col-lg-10 col-sm-12 col-12 text-left">
            {loading ? (
              <button
                className="btn sub_form btn_continue Save float-right"
                disabled
              >
                Loading...
              </button>
            ) : (
              <input
                type="submit"
                name="Submit"
                value="Submit"
                className="btn sub_form btn_continue Save float-right"
              />
            )}
          </div>
        </form>
      </div>
    </Fragment>
  );
};

AddPurpose.propTypes = {
  auth: PropTypes.object.isRequired,
  AddLoanReason: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  AddLoanReason,
})(AddPurpose);
